import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs/Rx';

@Injectable()
export class UserService {

  public user: Subject<any>;

  public userInfo = {
    username: 'Guest'
  };

  constructor() {
    this.user = new Subject();
  }

  getLoginInfo(): Observable<any> {
    const user = {
      username: localStorage.getItem('user_name'),
      picture: localStorage.getItem('user_profile_pic'),
      activity: 12
    };
    this.userInfo = user;
    this.user.next(user);
    return Observable.of(user);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/user/user.service.ts